import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import App from "./components/App";
import Loadable from "react-loadable";
import Loading from "./components/helpers/loading";
import React from "react";
import ReactDOM from "react-dom";
import Root from "./Root";
import withTracker from "./withTracker";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import CouponList from "./components/Mobile/Cart/Coupon/CouponList/CouponList";
// import RedirectHandler from "./redirect-handler";

// import NotFound from "./components/NotFound";
const NotFound = Loadable({
  loader: () => import("./components/NotFound"),
  loading: () => <Loading />,
});

// import Location from "./components/Mobile/Location";
const Location = Loadable({
  loader: () => import("./components/Mobile/Location"),
  loading: () => <Loading />,
});

// import Login from "./components/Mobile/Auth/Login";
const Login = Loadable({
  loader: () => import("./components/Mobile/Auth"),
  loading: () => <Loading />,
});

// import Register from "./components/Mobile/Auth/Register";
const Register = Loadable({
  loader: () => import("./components/Mobile/Auth/Register"),
  loading: () => <Loading />,
});

// import CartPage from "./components/Mobile/Cart";
const CartPage = Loadable({
  loader: () => import("./components/Mobile/Cart"),
  loading: () => <Loading />,
});

// import Account from "./components/Mobile/Account";
const Account = Loadable({
  loader: () => import("./components/Mobile/Account"),
  loading: () => <Loading />,
});

// import Explore from "./components/Mobile/Explore";
const Explore = Loadable({
  loader: () => import("./components/Mobile/Explore"),
  loading: () => <Loading />,
});

// import ContentScreen from "./components/Mobile/ContentScreen";
const ContentScreen = Loadable({
  loader: () => import("./components/Mobile/ContentScreen"),
  loading: () => <Loading />,
});

// import Addresses from "./components/Mobile/Account/Addresses";
const Addresses = Loadable({
  loader: () => import("./components/Mobile/Account/Addresses"),
  loading: () => <Loading />,
});

// import Checkout from "./components/Mobile/Checkout";
const Checkout = Loadable({
  loader: () => import("./components/Mobile/Checkout"),
  loading: () => <Loading />,
});

// import RunningOrder from "./components/Mobile/RunningOrder";
const RunningOrder = Loadable({
  loader: () => import("./components/Mobile/RunningOrder"),
  loading: () => <Loading />,
});

// import Orders from "./components/Mobile/Account/Orders";
const Orders = Loadable({
  loader: () => import("./components/Mobile/Account/Orders"),
  loading: () => <Loading />,
});

// import WalletPage from "./components/Mobile/Account/Wallet";
const WalletPage = Loadable({
  loader: () => import("./components/Mobile/Account/Wallet"),
  loading: () => <Loading />,
});
/* Delivery */
// import Delivery from "./components/Delivery";
const Delivery = Loadable({
  loader: () => import("./components/Delivery"),
  loading: () => <Loading />,
});

// import DeliveryLogin from "./components/Delivery/Login";
const DeliveryLogin = Loadable({
  loader: () => import("./components/Delivery/Login"),
  loading: () => <Loading />,
});

// import DeliveryOrders from "./components/Delivery/Orders";
const DeliveryOrders = Loadable({
  loader: () => import("./components/Delivery/Orders"),
  loading: () => <Loading />,
});

// import ViewOrder from "./components/Delivery/ViewOrder";
const ViewOrder = Loadable({
  loader: () => import("./components/Delivery/ViewOrder"),
  loading: () => <Loading />,
});

// import GeoLocationPage from "./components/Mobile/GeoLocationPage";
const GeoLocationPage = Loadable({
  loader: () => import("./components/Mobile/GeoLocationPage"),
  loading: () => <Loading />,
});

const ItemsParent = Loadable({
  loader: () => import("./components/Mobile/Items/ItemsParent"),
  loading: () => <Loading />,
});

const SingleItemParent = Loadable({
  loader: () => import("./components/Mobile/Items/SingleItemParent"),
  loading: () => <Loading />,
});

const SinglePage = Loadable({
  loader: () => import("./components/SinglePage"),
  loading: () => <Loading />,
});

const ForgotPassword = Loadable({
  loader: () => import("./components/Mobile/Auth/ForgotPassword"),
  loading: () => <Loading />,
});

const RestaurantListOnCategory = Loadable({
  loader: () => import("./components/Mobile/Home/RestaurantListOnCategory"),
  loading: () => <Loading />,
});

const RatingAndReview = Loadable({
  loader: () => import("./components/Mobile/Account/Orders/RatingAndReview"),
  loading: () => <Loading />,
});
const ViewStoreReviews = Loadable({
  loader: () => import("./components/Mobile/StoreReviews"),
  loading: () => <Loading />,
});

const Alerts = Loadable({
  loader: () => import("./components/Mobile/Alerts"),
  loading: () => <Loading />,
});

const FavoriteRestaurantList = Loadable({
  loader: () => import("./components/Mobile/Home/FavoriteRestaurants"),
  loading: () => <Loading />,
});

// Import Phase2 components
const Phase2 = Loadable({
  loader: () => import("./components/Mobile/Phase2"),
  loading: () => <Loading />,
});

const Phase2Category = Loadable({
  loader: () => import("./components/Mobile/Phase2/Category"),
  loading: () => <Loading />,
});

const Phase2Product = Loadable({
  loader: () => import("./components/Mobile/Phase2/Product"),
  loading: () => <Loading />,
});

const Phase2Browse = Loadable({
  loader: () => import("./components/Mobile/Phase2/Browse"),
  loading: () => <Loading />,
});

const Phase2Explore = Loadable({
  loader: () => import("./components/Mobile/Phase2/Explore"),
  loading: () => <Loading />,
});

const Phase2MyAccount = Loadable({
  loader: () => import("./components/Mobile/Phase2/MyAccount"),
  loading: () => <Loading />,
});

const LandingPage = Loadable({
  loader: () => import("./components/Mobile/LandingPage/LandingPage"),
  loading: () => <Loading />,
});

// Global error handling for userAgent issues
if (typeof window !== 'undefined') {
  window.addEventListener('error', function(event) {
    if (event.error && event.error.message && 
        event.error.message.includes('Cannot redefine property: userAgent')) {
      console.warn('Caught and suppressed userAgent redefinition error:', event.error.message);
      event.preventDefault();
      return false;
    }
  });

  // Additional protection for unhandled rejections
  window.addEventListener('unhandledrejection', function(event) {
    if (event.reason && event.reason.message && 
        event.reason.message.includes('Cannot redefine property: userAgent')) {
      console.warn('Caught and suppressed userAgent redefinition promise rejection:', event.reason.message);
      event.preventDefault();
      return false;
    }
  });
}

const ScrollToTop = () => {
  window.scrollTo(0, 0);
  return null;
};

const RedirectToStore = ({ match }) => {
  const { productId } = match.params;
  const storePath = `/stores/${productId}`;
  return <Redirect to={storePath} />;
};

const RedirectToItem = ({ match }) => {
  const { productId, id } = match.params;

  // if (id) {
  const itemPath = `/stores/${productId}/${id}`;
  return <Redirect to={itemPath} />;
  // } else {
  //   const storePath = `/stores/${productId}`;
  //   return <Redirect to={storePath} />;
  // }
};

ReactDOM.render(
  <Root>
    <BrowserRouter>
      <React.Fragment>
        <Route component={ScrollToTop} />
        <Switch>
          <Route path={"/"} exact component={withTracker(App)} />

          <Route path={"/landing"} exact component={withTracker(LandingPage)} />

          {/* Phase2 Sub-Routes (keeping these for deep linking) */}
          <Route path={"/phase2/categories"} exact component={withTracker(Phase2Category)} />
          <Route path={"/phase2/category/:slug"} exact component={withTracker(Phase2Category)} />
          <Route path={"/phase2/products/:categorySlug/:subcategorySlug"} exact component={withTracker(Phase2Product)} />
          <Route path={"/phase2/product/:slug"} exact component={withTracker(Phase2Product)} />
          <Route path={"/phase2/browse/:tag"} exact component={withTracker(Phase2Browse)} />
          <Route path={"/phase2/explore"} exact component={withTracker(Phase2Explore)} />
          <Route path={"/phase2/my-account"} exact component={withTracker(Phase2MyAccount)} />

          <Route
            path={"/search-location"}
            exact
            component={withTracker(Location)}
          />
          <Route
            path={"/my-location"}
            exact
            component={withTracker(GeoLocationPage)}
          />

          <Route
            path={"/categories/stores"}
            exact
            component={withTracker(RestaurantListOnCategory)}
          />

          <Route
            path={"/public/product/:productId"}
            exact
            component={RedirectToStore}
          />

          <Route
            path={"/public/product/:productId/:id"}
            exact
            component={RedirectToItem}
          />

          {/* <RedirectHandler /> */}

          <Route
            path={"/stores/:restaurant"}
            exact
            component={withTracker(ItemsParent)}
          />

          <Route
            path={"/stores/:restaurant/:id"}
            exact
            component={withTracker(SingleItemParent)}
          />

          <Route path={"/explore"} exact component={withTracker(Explore)} />

          <Route
            path={"/content-screen"}
            exact
            component={withTracker(ContentScreen)}
          />

          <Route path={"/login"} exact component={withTracker(Login)} />
          <Route
            path={"/login/forgot-password"}
            exact
            component={withTracker(ForgotPassword)}
          />
          <Route path={"/register"} exact component={withTracker(Register)} />

          <Route path={"/my-account"} exact component={withTracker(Account)} />
          <Route path={"/alerts"} exact component={withTracker(Alerts)} />
          <Route
            path={"/my-addresses"}
            exact
            component={withTracker(Addresses)}
          />
          <Route
            path={"/my-wallet"}
            exact
            component={withTracker(WalletPage)}
          />
          <Route path={"/my-orders"} exact component={withTracker(Orders)} />
          <Route
            path={"/rate-order/:id"}
            exact
            component={withTracker(RatingAndReview)}
          />
          <Route
            path={"/reviews/:slug"}
            exact
            component={withTracker(ViewStoreReviews)}
          />

          <Route path={"/checkout"} exact component={withTracker(Checkout)} />
          <Route
            path={"/running-order/:unique_order_id"}
            exact
            component={withTracker(RunningOrder)}
          />

          <Route path={"/cart"} exact component={withTracker(CartPage)} />

          <Route
            path={"/pages/:slug"}
            exact
            component={withTracker(SinglePage)}
          />
          <Route
            path={"/my-favorite-stores"}
            exact
            component={withTracker(FavoriteRestaurantList)}
          />
          <Route
            path={"/coupon-list"}
            exact
            component={withTracker(CouponList)}
          />
          <Route path={"/delivery"} exact component={Delivery} />
          <Route path={"/delivery/login"} exact component={DeliveryLogin} />
          <Route path={"/delivery/orders"} exact component={DeliveryOrders} />
          <Route
            path={"/delivery/orders/:unique_order_id"}
            exact
            component={ViewOrder}
          />
          <Route
            path={"/delivery/completed-orders"}
            exact
            component={Delivery}
          />
          {/* Common Routes */}
          <Route component={NotFound} />
          {/* <Route path={"/shared"} component={ShareItemAndStore} /> */}
        </Switch>
      </React.Fragment>
    </BrowserRouter>
  </Root>,
  document.getElementById("root")
);

// Register the service worker for PWA support and push notifications
serviceWorkerRegistration.register();
